import React, { useState, useEffect } from "react";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import PaymentDetails from "./Components/PaymentDetails";
import Loader from "./Components/Loader";

const PaymentFormPage=()=>{

      useEffect(()=>{
                    document.title="Payment Form | Balaji Badminton Academy"
                  },[]);

    return(
        <>
            <Header />
            <Loader/>
                <PaymentDetails/>
            <Footer/>
        </>
    );
}

export default PaymentFormPage;